module.exports = __webpack_public_path__ + "media/images/icon__compete-4de3e9fdd0ba9204bab50295fd6e7394.png";